module.exports = __webpack_public_path__ + "img/other_realme1.dd2d7aaf.jpg";